import {createContext as $bTzgH$createContext, useContext as $bTzgH$useContext, useState as $bTzgH$useState} from "react";
import {EditableText as $bTzgH$EditableText} from "@blueprintjs/core";
import $bTzgH$classnames from "classnames";
import $bTzgH$reactdraggable from "react-draggable";
import {ErrorBoundary as $bTzgH$ErrorBoundary} from "@macrostrat/ui-components";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;


var $aVUB5 = parcelRequire("aVUB5");



var $4bJ9d = parcelRequire("4bJ9d");

var $fwzVu = parcelRequire("fwzVu");

var $dl5CL = parcelRequire("dl5CL");
var $a7b81fcbce9aad59$exports = {};

$a7b81fcbce9aad59$exports = (parcelRequire("daZiC")).getBundleURL('bTzgH') + "connector.85e75ccf.js";




var $7j1lu = parcelRequire("7j1lu");

const $d931bc84f13910ef$export$cbc16735c48a2e0f = (0, $bTzgH$createContext)({
    inEditMode: false
});
const $d931bc84f13910ef$export$f3c30e51e696113d = function(props) {
    const { updateModel: updateModel } = (0, $aVUB5.useModelEditor)();
    const { note: note } = props;
    return (0, $4bJ9d.default)((0, $bTzgH$EditableText), {
        multiline: true,
        className: "col-note-label note-editing",
        defaultValue: note.note,
        isEditing: true,
        onConfirm (newText) {
            return updateModel({
                note: {
                    $set: newText
                }
            });
        }
    });
};
function $d931bc84f13910ef$export$63b2a30da318abf8(props) {
    let { children: children, inEditMode: inEditMode = false, noteEditor: noteEditor } = props;
    const { notes: notes } = (0, $bTzgH$useContext)((0, $dl5CL.NoteLayoutContext));
    const [editingNote, setEditingNote] = (0, $bTzgH$useState)(null);
    const deleteNote = function() {
        const val = editingNote;
        setEditingNote(null);
        return props.onDeleteNote(val);
    };
    const onCreateNote = function(pos) {
        const { height: height, top_height: top_height } = pos;
        const val = {
            height: height,
            top_height: top_height,
            note: null,
            symbol: null
        };
        return setEditingNote(val);
    };
    const value = {
        editingNote: editingNote,
        setEditingNote: setEditingNote,
        deleteNote: deleteNote,
        inEditMode: inEditMode,
        noteEditor: noteEditor,
        onCreateNote: onCreateNote
    };
    const onConfirmChanges = function(n) {
        if (n?.note == null && n == editingNote) {
            console.log("No changes to note");
            return;
        }
        if (notes.includes(n)) return;
        return props.onUpdateNote(n);
    };
    //# Model editor provider gives us a nice store
    return (0, $4bJ9d.default)($d931bc84f13910ef$export$cbc16735c48a2e0f.Provider, {
        value: value
    }, [
        (0, $4bJ9d.default)((0, $aVUB5.ModelEditorProvider), {
            model: editingNote,
            onDelete: deleteNote,
            onConfirmChanges: onConfirmChanges,
            logUpdates: true,
            alwaysConfirm: true
        }, children)
    ]);
}
const $d931bc84f13910ef$var$NoteConnectorPath = function(props) {
    const { d: d, offsetX: offsetX, className: className } = props;
    return (0, $4bJ9d.default)("path", {
        d: d,
        className: className,
        transform: `translate(${offsetX})`,
        fill: "transparent"
    });
};
const $d931bc84f13910ef$var$EditableNoteConnector = function(props) {
    const { notes: notes, nodes: nodes, columnIndex: columnIndex, generatePath: generatePath, createNodeForNote: createNodeForNote } = (0, $bTzgH$useContext)((0, $dl5CL.NoteLayoutContext));
    let { note: note, node: node, index: index } = props;
    if (note.id != null) node = nodes[note.id];
    if (node == null) node = createNodeForNote(note);
    const x = columnIndex[note.id] * 5 || 0;
    const d = generatePath(node, x);
    return (0, $4bJ9d.default)([
        (0, $4bJ9d.default)($d931bc84f13910ef$var$NoteConnectorPath, {
            className: "note-connector",
            d: d,
            offsetX: x
        }),
        (0, $4bJ9d.default)((0, $fwzVu.ForeignObject), {
            width: 30,
            x: x,
            y: 0,
            height: 1,
            style: {
                overflowY: "visible"
            }
        }, (0, $4bJ9d.default)($d931bc84f13910ef$var$PositionEditorInner, {
            note: note
        }))
    ]);
};
const $d931bc84f13910ef$var$PointHandle = function(props) {
    let { height: height, size: size, className: className, ...rest } = props;
    className = (0, $bTzgH$classnames)("handle point-handle", className);
    if (size == null) size = 10;
    return (0, $4bJ9d.default)((0, $bTzgH$reactdraggable), {
        position: {
            x: 0,
            y: height
        },
        axis: "y",
        ...rest
    }, (0, $4bJ9d.default)("div.handle", {
        style: {
            height: size,
            width: size,
            marginLeft: -size / 2,
            marginTop: -size / 2,
            position: "absolute"
        },
        className: className
    }));
};
function $d931bc84f13910ef$var$PositionEditorInner(props) {
    let updateModel;
    let { note: note, margin: margin } = props;
    if (margin == null) margin = 3;
    const { scaleClamped: scale } = (0, $bTzgH$useContext)((0, $aVUB5.ColumnContext));
    ({ updateModel: updateModel, editedModel: note } = (0, $aVUB5.useModelEditor)());
    if (note == null) return null;
    const noteHasSpan = (0, $7j1lu.hasSpan)(note);
    const bottomHeight = scale(note.height);
    let topHeight = bottomHeight;
    let height = 0;
    if (noteHasSpan) {
        topHeight = scale(note.top_height);
        height = Math.abs(topHeight - bottomHeight);
    }
    const moveEntireNote = function(e, data) {
        const { y: y } = data;
        // Set note height
        const spec = {
            height: {
                $set: scale.invert(y + height)
            }
        };
        if (noteHasSpan) // Set note top height
        spec.top_height = {
            $set: scale.invert(y)
        };
        return updateModel(spec);
    };
    const moveTop = function(e, data) {
        const spec = {
            top_height: {
                $set: scale.invert(data.y)
            }
        };
        if (Math.abs(data.y - bottomHeight) < 2) spec.top_height = {
            $set: null
        };
        return updateModel(spec);
    };
    const moveBottom = function(e, data) {
        const spec = {
            height: {
                $set: scale.invert(data.y)
            }
        };
        if (Math.abs(data.y - topHeight) < 2) spec.top_height = {
            $set: null
        };
        return updateModel(spec);
    };
    return (0, $4bJ9d.default)((0, $bTzgH$ErrorBoundary), null, (0, $4bJ9d.default)("div.position-editor", [
        (0, $4bJ9d.default)((0, $bTzgH$reactdraggable), {
            handle: ".handle",
            position: {
                x: 0,
                y: topHeight
            },
            onDrag: moveEntireNote,
            axis: "y"
        }, (0, $4bJ9d.default)("div", [
            (0, $4bJ9d.default)("div.handle", {
                className: "handle",
                style: {
                    height: height,
                    width: 2 * margin,
                    marginLeft: -margin,
                    marginTop: -margin,
                    position: "absolute"
                }
            })
        ])),
        (0, $4bJ9d.default)($d931bc84f13910ef$var$PointHandle, {
            height: noteHasSpan ? topHeight : topHeight - 15,
            onDrag: moveTop,
            className: (0, $bTzgH$classnames)("top-handle", {
                "add-span-handle": !noteHasSpan
            }),
            bounds: {
                bottom: bottomHeight
            }
        }),
        (0, $4bJ9d.default)($d931bc84f13910ef$var$PointHandle, {
            height: bottomHeight,
            onDrag: moveBottom,
            className: "bottom-handle",
            bounds: noteHasSpan ? {
                top: topHeight
            } : null
        })
    ]));
}
const $d931bc84f13910ef$var$NoteEditorUnderlay = function({ padding: padding }) {
    const { width: width } = (0, $bTzgH$useContext)((0, $dl5CL.NoteLayoutContext));
    const { setEditingNote: setEditingNote } = (0, $bTzgH$useContext)($d931bc84f13910ef$export$cbc16735c48a2e0f);
    return (0, $4bJ9d.default)((0, $dl5CL.NoteRect), {
        fill: "rgba(255,255,255,0.8)",
        style: {
            pointerEvents: "none"
        },
        className: "underlay"
    });
};
const $d931bc84f13910ef$export$9939e67821493b95 = function(props) {
    const { allowPositionEditing: allowPositionEditing } = props;
    const { noteEditor: noteEditor } = (0, $bTzgH$useContext)($d931bc84f13910ef$export$cbc16735c48a2e0f);
    const { notes: notes, nodes: nodes, elementHeights: elementHeights, createNodeForNote: createNodeForNote } = (0, $bTzgH$useContext)((0, $dl5CL.NoteLayoutContext));
    const { editedModel: editedModel } = (0, $aVUB5.useModelEditor)();
    if (editedModel == null) return null;
    const index = notes.indexOf(editedModel);
    const { id: noteID } = editedModel;
    let node = nodes[noteID] || createNodeForNote(editedModel);
    const noteHeight = elementHeights[noteID] || 20;
    if (editedModel.height != null) {
        const newNode = createNodeForNote(editedModel);
        // Set position of note to current position
        newNode.currentPos = node.currentPos;
        const pos = newNode.centerPos || newNode.idealPos;
        const dy = pos - node.currentPos;
        if (dy > 50) newNode.currentPos = pos - 50;
        if (dy < -50) newNode.currentPos = pos + 50;
        node = newNode;
    }
    return (0, $4bJ9d.default)((0, $bTzgH$ErrorBoundary), [
        (0, $4bJ9d.default)("g.note-editor.note", [
            (0, $4bJ9d.default)($d931bc84f13910ef$var$NoteEditorUnderlay),
            (0, $4bJ9d.default).if(!allowPositionEditing)((0, $a7b81fcbce9aad59$exports.NoteConnector), {
                note: editedModel
            }),
            (0, $4bJ9d.default).if(allowPositionEditing)($d931bc84f13910ef$var$EditableNoteConnector, {
                note: editedModel,
                node: node
            }),
            (0, $4bJ9d.default)((0, $a7b81fcbce9aad59$exports.NotePositioner), {
                offsetY: node.currentPos,
                noteHeight: noteHeight
            }, [
                (0, $4bJ9d.default)(noteEditor, {
                    note: editedModel,
                    key: index
                })
            ])
        ])
    ]);
};


//# sourceMappingURL=editor.ffa16e31.js.map
